import { supabase } from "../lib/supabase";

function rowToTour(row) {
  if (!row) return null;
  return {
    id: row.id,
    key: row.key,
    category: row.category,
    days: row.days,
    nights: row.nights,
    country: row.country,
    date: row.date,
    price: row.price,
    tag: row.tag,
    visibleFrom: row.visible_from || undefined,
    image: row.image,
    blogText: row.blog_text || { hr: "", en: "", de: "", es: "" },
    gallery: Array.isArray(row.gallery) ? row.gallery : [],
    detailedInfo: row.detailed_info || { hr: "", en: "", de: "", es: "" },
  };
}

function tourToRow(tour) {
  return {
    key: tour.key,
    category: tour.category,
    days: tour.days,
    nights: tour.nights,
    country: tour.country,
    date: tour.date,
    price: tour.price,
    tag: tour.tag,
    visible_from: tour.visibleFrom || null,
    image: tour.image,
    blog_text: tour.blogText || { hr: "", en: "", de: "", es: "" },
    gallery: tour.gallery || [],
    detailed_info: tour.detailedInfo || { hr: "", en: "", de: "", es: "" },
    sort_order: tour.sort_order ?? tour.id ?? 0,
  };
}

export async function fetchTours() {
  const { data, error } = await supabase
    .from("tours")
    .select("*")
    .order("sort_order", { ascending: true })
    .order("date", { ascending: true });

  if (error) {
    console.error("Supabase fetchTours error:", error);
    return null;
  }
  return (data || []).map(rowToTour);
}

export async function createTour(tour) {
  const row = tourToRow(tour);
  const { data, error } = await supabase.from("tours").insert(row).select("id").single();
  if (error) {
    console.error("Supabase createTour error:", error);
    return { error };
  }
  return { data: { ...tour, id: data.id } };
}

export async function updateTour(tour) {
  const { id, ...rest } = tour;
  const row = tourToRow({ ...rest });
  delete row.sort_order;
  const { error } = await supabase.from("tours").update(row).eq("id", id);
  if (error) {
    console.error("Supabase updateTour error:", error);
    return { error };
  }
  return {};
}

export async function deleteTour(id) {
  const { error } = await supabase.from("tours").delete().eq("id", id);
  if (error) {
    console.error("Supabase deleteTour error:", error);
    return { error };
  }
  return {};
}
